define('services/chatService',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'enums/participantStatus',
    'models/Chat',
    'services/communicationService',
    'services/apiCore',
    'services/userService',
    'services/loggingService'
], function (_, ko, Promise, participantStatus, Chat, communicationService, apiCore, userService, LOG) {
    'use strict';

    var activeChats = ko.observableArray([]);

    var chatService = {

        uriBuilder: communicationService.createUriBuilder('/conversations'),

        activeChats: activeChats,

        /**
         * Get a specific chat
         * @param {string} chatId the chat id to fetch
         * @returns {promise} a promise that resolves to the chat
         */
        getChat: function (chatId) {
            return communicationService.getCommunication(this.uriBuilder, chatId)
                .then(function (chat) {
                    return new Chat(chat);
                });
        },


        /**
         * Get the chats for current user
         * @return {Promise}
         */
        getActiveChats: function() {
            return apiCore.v2.get(chatService.uriBuilder.communicationsByType('chat'));
        }

    };

    communicationService.subscribeToTopic('conversations.chats', chatService.activeChats, chatService.getActiveChats, Chat);

    /**
     * Keeps the list of active chats to actually only contain those that are active
     */
    ko.computed(function () {
        chatService.activeChats(_.filter(chatService.activeChats(), function (chat) {
            if (_.has(chat, 'active')) {
                return chat.active();
            }
            return false;
        }));
    });

    /**
     * This computed will get triggered when the user is in non-responding state. It will
     * request the list of valid chats and compare with the current list loaded in chatViews.
     * chats that exist in chatViews and not in the valid list will be removed.
     */
    ko.computed(function() {
        if (userService.currentUser() && userService.currentUser().isNotResponding()){
            chatService.getActiveChats()
                .then(function(response){

                    var resultArray = [];
                    _.each(response.entities, function(chat){
                        resultArray.push(new Chat(chat));
                    });
                    chatService.activeChats(resultArray);
                })
                .catch(function (err) {
                    LOG.error('The process to clean up non-responding chats failed.', err);
                });
        }
    });

    return chatService;
});

